const Modal = () => {
    return (
        <div
            className="modal fade"
            id="exampleModal"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-scrollable modal-xl modal-fullscreen-lg-down">
                <div className="modal-content h-100" style={{ borderRadius: "2%" }}>
                    <div className="modal-header bg-light-green">
                        <h1 className="modal-title fs-4 text-white text-center w-100" id="exampleModalLabel">
                            Advanced Search
                        </h1>
                        <button
                            type="button"
                            className="btn-close bg-white"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body px-0">
                        <iframe
                            className="h-100 w-100"
                            src="https://kr.camptratech.com/chatopenai/"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
